import { useWhoAmI } from '@/api/common/auth/hooks';
import { useHydrateVesselScope } from '@/modules/HSQE/hooks/useHydrateVesselScope';

interface HsqeProviderProps {
  children: React.ReactNode;
}

/**
 * Composition-root provider that owns the HSQE module's cross-cutting concern: hydrating the
 * vessel-scope store once per session. It lives under `@/modules/HSQE` so the HSQE-owning code
 * keeps the `@/modules/HSQE` import; the shared `providers/` layer only references this provider
 * at the composition root, never the feature module directly (ADR-0090 / wiki
 * providers-composition-root.md).
 *
 * As a standalone provider it sources `user` itself from `useWhoAmI` (the enriched whoami
 * session) rather than receiving it as a call-site prop. Hydration is additive and no-ops for
 * non-HSQE sessions (the hook returns early when the session carries no vessel scope).
 */
export const HsqeProvider: React.FC<HsqeProviderProps> = ({ children }) => {
  const { data: whoAmIData } = useWhoAmI();

  useHydrateVesselScope(whoAmIData?.Security.User);

  return <>{children}</>;
};
